import { render, staticRenderFns } from "./healthBanner.vue?vue&type=template&id=2b134bf3&scoped=true&"
import script from "./healthBanner.vue?vue&type=script&lang=ts&"
export * from "./healthBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b134bf3",
  null
  
)

export default component.exports